import { EntityService } from '@/services/EntityService';

export class HolidaysService extends EntityService {
  static get entity() {
    return 'holiday';
  }
}
